<template>
  <div class="certificaiton_table_list">
    <div class="tit">
      <span>企业认证</span>
    </div>
    <div class="body_content">
      <!-- 企业认证 身份不为员工时可认证 -->
      <div v-if="info && info.role !=='UserRoleEmployee'">
        <!-- 1有认证过显示列表 -->
        <template v-if="tableSwitch===1">
          <div class="btns">
            <el-button type="primary" @click="go('enterprise_certification_from');">添加认证</el-button>
          </div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column fixed prop="enterprise_name" label="企业名称"></el-table-column>
            <el-table-column prop="incubator_name" label="申请园区"></el-table-column>
            <el-table-column prop="unified_code" label="社会信用代码" width="120"></el-table-column>
            <el-table-column prop="city_name" label="注册地区" width="120"></el-table-column>
            <el-table-column prop="corporation" label="法人代表" width="120"></el-table-column>
            <el-table-column prop="corporation_mobile" label="联系方式" width="120"></el-table-column>
            <el-table-column prop="status_name" label="认证状态" width="120">
               <template slot-scope="scope">
                 {{scope.row.status==='IdentityCertifieStatussuccess'?'通过':scope.row.status_name}}
               </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <!-- 未提交|| 已撤回 -->
                <div
                  class="center"
                  v-if="scope.row.status==='IdentityCertifieStatusNotSubmitted' || scope.row.status==='IdentityCertifieStatusWithdraw'"
                >
                  <div>
                    <div class="blue_btn" @click="backEdit(scope.row)">返回修改</div>
                  </div>
                </div>
                <!-- 已提交 -->
                <div
                  class="center"
                  v-else-if="scope.row.status==='IdentityCertifieStatusSubmitted'"
                >
                  <div>
                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                  </div>
                  <div>
                    <div class="blue_btn" @click="withdrawAuthenticateDialog(scope.row)">撤回认证</div>
                  </div>
                </div>
                <!--审核中 || 已核对   -->
                <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusInReview'">
                  <div>
                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                  </div>
                </div>
                <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatussuccess'">
                  <div>
                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                  </div>
                </div>
                <!--不通过 || 未通过   -->
                <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusFailed'">
                  <div>
                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                  </div>
                  <div>
                    <div class="blue_btn" @click="viewOpinions(scope.row)">查看意见</div>
                  </div>
                </div>
                <!-- 已退回 -->
                <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusReturned'">
                  <div>
                    <div class="blue_btn" @click="viewOpinions(scope.row)">查看意见</div>
                  </div>
                  <div>
                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                  </div>
                  <div>
                    <div class="blue_btn" @click="backEdit(scope.row)">返回修改</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
          </div>
        </template>
        <!--  2没有认证过显示去认证按钮-->
        <template v-else-if="tableSwitch===2">
          <el-button type="primary" @click="go('enterprise_certification_from')">去认证</el-button>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;您可以在此认证为企业身份，认证后可进行员工管理等操作</span>
        </template>
        <!-- 意见 -->
        <el-dialog title="查看意见" :visible.sync="dialogVisible" width="600px" center>
          <span v-if="row && row.examine_remark" v-cloak>{{row.examine_remark}}</span>
          <span v-else>暂无</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div v-else>已拥有员工身份</div>
    </div>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    myPage
  },
  data() {
    return {
      tableSwitch: 0, //模块展示判断
      certData: null, //认证数据
      tableData: [],
      layerpageinfo: {
        //分页
        pageNo: 0,
        total: 0,
        pageSize: 10
      },
      dialogVisible: false,
      row: null
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    this.getFrontAuthenticates();
  },
  methods: {
    /** 查询认证*/
    getFrontAuthenticates() {
      let params = Object.assign({}, this.layerpageinfo, {
        type: "CertificationTypeInnovate"
      });
      this.api.getFrontAuthenticates(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];
        this.tableData = list.length ? list : [];
        this.tableSwitch = list.length ? 1 : 2;
      });
    },
    /*页面跳转*/

    go(name) {
      this.$router.push({
        name: name
      });
      sessionStorage.removeItem("enterpriseCertificationTmpId"); //清空企业认证id
    },
    /*改变分页*/

    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontAuthenticates();
    },
    /*返回修改 编辑*/
    backEdit(item) {
      this.$router.push({
        name: "enterprise_certification_from",
        query: {
          id: item.id
        }
      });
    },
    /*查看详情*/

    detail(item) {
      this.$router.push({
        name: "enterprise_certification_details",
        query: {
          id: item.id
        }
      });
    },
    /* 撤回机构认证弹窗*/
    withdrawAuthenticateDialog(row) {
      this.$confirm("确定撤回认证?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.withdrawAuthenticate(row);
        })
        .catch(() => {});
    },
    /* 撤回机构认证 */
    withdrawAuthenticate(row) {
      this.api.withdrawAuthenticate({
          id: row.id
      }).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message({
          type: "success",
          message: "撤回成功!"
        });
        this.getFrontAuthenticates(); //列表
      });
    },
    /* 查看意见 */
    viewOpinions(row) {
      this.dialogVisible = true;
      this.row = row;
    },
  }
};
</script>

<style lang="scss" scoped>
.blue_btn {
  color: $font-blue;
  cursor: pointer;
}
</style>